import React from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

const Howwork = () => {
    const { t } = useTranslation();

    return (
        <section className='howwork how'>
            <Container>
                <Row>
                    <Col lg={6}>
                        <div className='howwork-content'>
                            <h3 className='title'>{t('howWeWork.title')}</h3>
                            <ul>
                                <li>
                                    <div className="nuber-box">1</div>
                                    <div><h4>{t('howWeWork.steps.card1.title1')}</h4><h4>{t('howWeWork.steps.card1.title2')}</h4></div>
                                </li>
                                <li>
                                    <div className="nuber-box">2</div>
                                    <div><h4>{t('howWeWork.steps.card2.title1')}</h4><h4>{t('howWeWork.steps.card2.title2')}</h4></div>
                                </li>
                                <li>
                                    <div className="nuber-box">3</div>
                                    <div><h4>{t('howWeWork.steps.card3.title1')}</h4><h4>{t('howWeWork.steps.card3.title2')}</h4></div>
                                </li>
                                <li>
                                    <div className="nuber-box">4</div>
                                    <div><h4>{t('howWeWork.steps.card4.title1')}</h4><h4>{t('howWeWork.steps.card4.title2')}</h4></div>
                                </li>
                            </ul>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="work-image">
                            <img src={require("../assets/images/how-work.png")} alt="img" className="img-fluid" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Howwork;
